import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "codeField", "countField",
    "userLimitField",
    "trialFields", "nonTrialFields", "percentField", "amountField",
    "exportCsvField",
    "couponSingle", "couponBulk"
  ]

  connect() {
    this.refreshCouponType()
    this.refreshCodeType()
    this.refreshUserLimit()
    this.refreshUnlimited()
  }

  // --- Coupon type: single vs bulk (solo en creación) ---
  selectCouponType(event) {
    const type = event.currentTarget.dataset.couponType
    const input = this.element.querySelector('input[name="discount_form[coupon_type]"]')
    if (input) input.value = type
    this.refreshCouponType()
  }

  refreshCouponType() {
    const input = this.element.querySelector('input[name="discount_form[coupon_type]"]')
    if (!input) return // edit mode: no coupon type selector

    const type = input.value || "single"

    if (this.hasCodeFieldTarget) this.toggle(this.codeFieldTarget, type === "single")
    if (this.hasCountFieldTarget) this.toggle(this.countFieldTarget, type === "bulk")
    if (this.hasExportCsvFieldTarget) this.toggle(this.exportCsvFieldTarget, type === "bulk")

    if (this.hasCouponSingleTarget) {
      this.couponSingleTarget.dataset.selected = (type === "single").toString()
    }
    if (this.hasCouponBulkTarget) {
      this.couponBulkTarget.dataset.selected = (type === "bulk").toString()
    }
  }

  // --- Code type: trial / percentage / amount ---
  changeCodeType() {
    this.refreshCodeType()
  }

  refreshCodeType() {
    const select = this.element.querySelector('select[name="discount_form[code_type]"]')
    const type = select ? select.value : ""

    this.toggle(this.trialFieldsTarget, type === "trial")
    this.toggle(this.nonTrialFieldsTarget, type !== "trial")
    if (this.hasPercentFieldTarget) this.toggle(this.percentFieldTarget, type === "percentage")
    if (this.hasAmountFieldTarget) this.toggle(this.amountFieldTarget, type === "amount")
  }

  // --- User limit toggle ---
  changeUserLimit() {
    this.refreshUserLimit()
  }

  refreshUserLimit() {
    const select = this.element.querySelector('select[name="discount_form[enable_user_limit]"]')
    const enabled = select ? select.value === "true" : false
    this.toggle(this.userLimitFieldTarget, enabled)
  }

  // --- Unlimited toggle ---
  changeUnlimited() {
    this.refreshUnlimited()
  }

  refreshUnlimited() {
    const checked = this.element.querySelector('input[name="discount_form[unlimited]"][value="true"]:checked')
    const usageLimitRow = this.element.querySelector('[data-usage-limit-row]')
    if (usageLimitRow) {
      this.toggle(usageLimitRow, !checked)
    }
  }

  // --- Helper ---
  toggle(target, show) {
    if (target) {
      show ? target.classList.remove("hidden") : target.classList.add("hidden")
    }
  }
}
